<template>
    <div class="w3-container w3-responsive">

      <!-- 加载状态 -->
      <div v-if="loading" class="w3-panel w3-green w3-display-container">
        <span class="w3-button w3-large w3-display-topright" @click="loading = false">×</span>
        <p>loading...</p>
      </div>
  
      <!-- 错误提示 -->
      <div v-if="error" class="w3-panel w3-red">
        <p>{{ error }}</p>
      </div>
  
      <!-- 数据列表 -->
      <table class="w3-table w3-striped w3-bordered w3-border w3-hoverable w3-white">
        <thead>
        <tr class="w3-green">
          <th>Name</th>
          <th>Submit</th>
          <th>Recv Addr</th>
          <th>Amt</th>
          <th>Status</th>
          <th>Act1</th>
          <th>Act2</th>                    
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in list" :key="item.RecordId" class="w3-padding">
          <td class="w3-text-grey">{{ item.UserName }}</td>
          <td class="w3-text-grey">{{ $filters.formatDate(item.SubmitDate) }}</td>
          <td class="w3-text-grey">{{ item.TronAddr }}</td>
          <td class="w3-text-grey">{{ $filters.formatNumber(item.Coin) }}</td>
          <td v-if="item.State==0" class="w3-text-green">{{ item.StateInfo }}</td>
          <td v-else-if="item.State==-1" class="w3-text-red">{{ item.StateInfo }}</td>          
          <td v-else class="w3-text-grey">{{ item.StateInfo }}</td>
          <td class="w3-button w3-text-green" ><span v-if="item.State == 1" @click="doComplete(item.RecordId)">Complete</span></td>
          <td class="w3-button w3-text-red" ><span v-if="item.State == 1" @click="doReject(item.RecordId)">Reject</span></td>

        </tr>
      </tbody>
      </table>
    </div>
  </template>
  
  <script>
 import axios from 'axios';

export default {
  data() {
    return {
      list: [],
      loading: false,
      error: '',
      userName: '',
      userPass: ''
    };
  },
  created() {

    const query = this.$route.query;

    if(query.u && query.p) {
      sessionStorage.setItem('userName', query.u);
      sessionStorage.setItem('userPass', query.p);
    }
    this.userName = sessionStorage.getItem('userName');
    this.userPass = sessionStorage.getItem('userPass');
    if(this.userName && this.userPass) {
      this.fetchData();
    } else {
      this.$router.push('/login');
    }
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.error = '';
      try {

        const response = await axios.get(`${this.$apiUrl}/getWithdrawTX?username=${this.userName}&t=${this.userPass}`);
        if(response.data.code !== 200) {
          this.error = response.data.msg;
          this.$router.push('/login?err=1');
          return;
        } 
        this.list = response.data.result;
      } catch (err) {
        this.error = '获取数据失败，请稍后重试。';
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    doComplete(recordId) {
      if(confirm("Comfirm to complete this withdraw transaction?")) {
        axios.get(`${this.$apiUrl}/completeWithdrawTX?username=${this.userName}&t=${this.userPass}&recordId=${recordId}`)
        .then(response => {
          alert(response.data.result);
          this.fetchData();
        })
        .catch(err => {
          this.error = 'operation failed, please try again later.';
          alert(this.error);
          console.error(err);
        });
      }
    },
    doReject(recordId) {
      if(confirm("Confirm to reject this withdraw transaction?")) {
        axios.get(`${this.$apiUrl}/rejectWithdrawTX?username=${this.userName}&t=${this.userPass}&recordId=${recordId}`)
        .then(response => {
          alert(response.data.result);
          this.fetchData();
        })
        .catch(err => {
          this.error = 'operation failed, please try again later.';
          alert(this.error);
          console.error(err);
        });
      }
    }    
  }
};
  </script>
  
  <style scoped>
  /* 可选：添加自定义样式覆盖或补充 W3.CSS */
  .w3-container {
    margin: 0px auto;
    padding: 0px;
  }
  
  .w3-ul li {
    transition: background-color 0.3s;
  }
  .w3-ul li:hover {
    background-color: #f0f0f0;
  }
  </style>